import _ from "lodash"
import EventBus from "../EventBus";

export default {
    data() {
        return {
            heightToFill: 100,
            heightToReduce: 100,
        }
    },
    mounted() {
        this.calculateTableHeight();
    },
    created() {
        window.addEventListener("resize", this.calculateTableHeight);
        EventBus.$on("ContainerResizedEvent", this.onContainerResize)
    },
    destroyed() {
        window.removeEventListener("resize", this.calculateTableHeight);
        EventBus.$off("ContainerResizedEvent", this.onContainerResize)
    },
    methods: {
        calculateTableHeight: _.debounce(function () {
            let calculatedHeight = window.innerHeight - this.$refs.HeightAdjusterTarget.getBoundingClientRect().top - this.heightToReduce;
            this.heightToFill = calculatedHeight < 200 ? 200 : calculatedHeight + 40;
        }, 10),
        onContainerResize: function () {
            this.calculateTableHeight()
        }
    }
}